import { getRules } from 'utils/util'

// 批量申请待审批列表
export const BATCH_APPLY_SEARCH_SCHEMA = [
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
]

export const BATCH_SEARCH_SCHEMA = [
  {
    itemName: 'id',
    label: '批量申请编号',
    type: 'input',
    allowClear: true,
  },
  {
    itemName: 'applyRangeDate',
    label: '添加时间',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
  {
    itemName: 'status',
    label: '状态',
    type: 'select',
    allowClear: true,
    selectList: [
      {
        text: '验证通过',
        value: 1,
      },
      {
        text: '验证不通过',
        value: 2,
      },
      {
        text: '审批中',
        value: 3,
      },
      {
        text: '审批通过',
        value: 4,
      },
      {
        text: '审批拒绝',
        value: 5,
      },
    ],
  },
]
export const CREDIT_ALLOCATION_SCHEMA = {
  parentName: {
    label: '授信企业(母公司)',
    slotName: 'parent',
  },
  childCode: {
    label: '子公司',
    type: 'select',
    optionList: [],
    fieldNames: { label: 'name', value: 'code' },
    rules: getRules('请选择子公司'),
  },
  amount: {
    label: '授信额度',
    type: 'input',
    handleInputCheck: 'checkFloat2',
    rules: getRules('请输入授信额度'),
  },
}

export const CREDIT_SEARCH_SCHEMA = [
  {
    itemName: 'parentCode',
    label: '母公司ID/名称',
    type: 'input',
  },
  {
    itemName: 'childCode',
    label: '子公司ID/名称',
    type: 'input',
  },
  // {
  //   itemName: 'createTimeRange',
  //   label: '授信时间',
  //   type: 'rangePicker',
  //   format: 'YYYY-MM-DD',
  //   allowClear: true,
  // },
  // {
  //   itemName: 'indateRange',
  //   label: '有效时间',
  //   type: 'rangePicker',
  //   format: 'YYYY-MM-DD',
  //   allowClear: true,
  // },
]

export const ACCOUNT_ALLOCATION_SCHEMA = {
  parentName: {
    label: '授信企业(母公司)',
    slotName: 'parent',
  },
  childCode: {
    label: '子公司',
    type: 'select',
    optionList: [],
    fieldNames: { label: 'name', value: 'code' },
    rules: getRules('请选择子公司'),
  },
  type: {
    label: '额度类型',
    type: 'select',
    optionList: [
      {
        label: '正常额度',
        value: 2,
      },
      {
        label: '临时额度',
        value: 3,
      },
    ],
    rules: getRules('请选择额度类型'),
    emit: 'typeSelectChange',
  },
  creditArea: {
    label: '信控区',
    type: 'select',
    optionList: [],
    fieldNames: { label: 'name', value: 'name' },
  },
  amount: {
    label: '额度金额',
    type: 'input',
    handleInputCheck: 'checkFloat2',
    rules: getRules('请输入额度金额'),
  },
}

export const RELATION_SEARCH_SCHEMA = [
  {
    itemName: 'parentCode',
    label: '母公司ID',
    type: 'input',
    allowClear: true,
  },
  {
    itemName: 'parentName',
    label: '母公司名称',
    type: 'input',
    allowClear: true,
  },
  {
    itemName: 'relationType',
    label: '关联类型',
    type: 'select',
    selectList: [
      { text: '关联共享', value: 1 },
      { text: '关联分配', value: 2 },
    ],
    allowClear: true,
  },
  {
    itemName: 'childCode',
    label: '子公司ID',
    type: 'input',
    allowClear: true,
  },
  {
    itemName: 'childName',
    label: '子公司名称',
    type: 'input',
    allowClear: true,
  },
  {
    itemName: 'relationStatus',
    label: '关联状态',
    type: 'select',
    selectList: [
      { text: '关联中', value: 1 },
      { text: '已解绑', value: 2 },
    ],
    allowClear: true,
  },
  {
    itemName: 'applier',
    label: '申请人',
    type: 'input',
    allowClear: true,
  },
  {
    itemName: 'applyStatus',
    label: '申请状态',
    type: 'select',
    selectList: [
      { text: '审批中', value: 1 },
      { text: '审批通过', value: 2 },
      { text: '审批否决', value: 3 },
      { text: '已撤销', value: 4 },
    ],
    allowClear: true,
  },
  {
    itemName: 'creditManager',
    label: '信用主管',
    type: 'select',
    selectList: [],
    allowClear: true,
  },
]
